import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'
import Flipping from 'flipping/dist/flipping.web';
import App from './App.vue'
import router from './router'
 
import '@fortawesome/fontawesome-free/css/all.css';

Vue.config.productionTip = false
Vue.use(Vue2TouchEvents)

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')

const flip = new Flipping({
	onRead: (s) => {
		for (let ss of Object.keys(s))
			s[ss].element.removeAttribute('data-flip-key')
	}
})

router.beforeEach((to, from, next) => {
	flip.read();
	next();
})

router.afterEach(() => {
	setTimeout(() => flip.flip());
})
